import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { blockTeeTime, getTeeTimeBook, getTeeTimeInit } from "../api/teeTimeAPI";

const slot = (props) => {
    const [teeTimeBook, setTeeTimeBook] = useState([]);
    const [refresh,             setRefresh]             = useState(false);
    useEffect(() => {
        $('#modalSlot').modal({ backdrop: 'static', keyboard: false });
        $(props.from).addClass('modal-blur'); 
        $('#modalSlot').on('hidden.bs.modal', function () {           
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(false);
        });
    }, [])

    

    useEffect(()=> { 
            if(props.date) fetchTeeSlot() 
    }, [refresh]);   

    const refetchTeeTime = ()=> setRefresh((r) => !r);
    useEffect(()=> { 
        if(!!props?.socketMaster){
            props.socketMaster.on('refresh-teesheet', (res) => {
                const {data} = res;     
                
                if(data){
                    if(data.Action == 'Refresh') return refetchTeeTime();
                    
                    if((data?.TeeTimeBook.length > 0) ||(data?.ShotgunBook.length > 0)){
                        if (data.Type === 'Shotgun')
                            setShotgunBook(data.ShotgunBook);//not required
                        else
                            setTeeTimeBook(data.TeeTimeBook);
                    }
                }
            });
        }       
    },[props]);  

    const fetchTeeSlot = async () => {
        const tee = await getTeeTimeBook(props.date)
        setTeeTimeBook(tee.TeeTimeBook)
    }

    const handleSlot = async (book, Captcha = false) => {

        if (props.from === "header") return;
        try {
            // if (props.oldSlot.TemplateID == book.TemplateID) {
            //     swal.close();
            //     $('#modalSlot').modal('hide');
            //     onClose()
            //     return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Can't Book Same Slot` });
            // }
            if( book.Status === "Booked" || book.Status === "Pending"){
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Slot Already Occupied` });
            } 
            if ((4 - Number(book.UserCount)) < Number(props.totalMembersCount)) {
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'No Available Slot' });
            }
            if (book.Status == "Available" || book.Status === "Remaining" || book.Status == null) {
                props.setSlot({
                    Slot: book.Slot,
                    TemplateID: book.TemplateID
                })

                setTimeout(() => {
                    if (typeof $ !== "undefined") {
                    $("#modalSlot").modal("hide");
                    if (props.from) {
                        $(props.from).removeClass("modal-blur");
                    }
                    }
                }, 50);
            } else {
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Slot Not Available` });
            }
        } catch (error) {
          console.error("Error adding player:", error);
        }
    }; 

    const onClose = () => $(props.from).removeClass('modal-blur');

    return (<>
        <div id="modalSlot" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header padding-b0">
                        <button type="button" className="close" data-dismiss="modal"> <span aria-hidden="true" onClick={onClose}> &times; </span> </button>
                        <h5 className="modal-title" id="member-modal-title"> Select Slot</h5>
                    </div>
                    <div id="pnlTeeBtn" className="row padding-lr10 padding-t15">
                            <div className="col-xs-6">
                                <button id="btnTeeBox1" type="button" className="btn btn-default btn-block btn-success"
                                > 1st Tee </button>
                            </div>
                            <div className="col-xs-6">
                                <button id="btnTeeBox10" type="button" className="btn btn-default btn-block"                                  
                                > 10th Tee </button>
                            </div>
                    </div>
                    <div className="modal-body overflow-x padding-30 margin-20">
                        <div id="ModalSlot">
                            <div className="row" id="slotContainer">
                                <div className="col-sx-12">
                                    <table id="tableSlot" className="table table-hover">
                                        <tbody>
                                            <div id="divTeeTime" className="row">
                                    <div className='col-xs-5' >
                                        <div className="row">
                                            {teeTimeBook.filter(f => f.TeeBox == 1).map((m, i) => (
                                                <div className="col-md-6 col-sm-6 col-lg-3 padding-0" style={{}} key={m.TemplateID} >
                                                    <div className={` slot-card ${m.TemplateID == props.slot?.TemplateID && `slot-card-selected`} ${(m.Status == "Booked" ) && 'disableClick'}`} onClick={() => handleSlot(m)} >
                                                        <div className={`${ (m.Status == "Available" || m.Status == "Remaining" || m.Status == null) ? 'slot-card-header':(m.Status == 'Pending')? 'slot-card-header-pending' :'slot-card-header-blur' }`}> 
                                                            <div className="row margin-0">
                                                                <div className="col-xs-12 padding-0">
                                                                    <b> {m.Slot} </b>  
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slot-card-available-wrapper">
                                                            <div className="slot-card-available">
                                                                {/* {m.Status ? m.Status : "Available" }{(m.Status != "Booked" && m.Status != 'Pending') ? <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i> : <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>} */}
                                                                <div className="slot-card-available">
                                                                {m.Status === "Available" || m.Status === null ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>Available</span>
                                                                    </div>
                                                                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : m.Status === "Remaining" ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>{m.DisplayStatus}</span>
                                                                    </div>
                                                                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : m.Status === "Pending" || m.Status === "Booked" ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>{m.Status}</span>
                                                                    </div>
                                                                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                    <div className="">
                                                                        <span>Not Available</span>
                                                                    </div>
                                                                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-xs-2"></div>
                                    <div className='col-xs-5'>
                                        <div className="row">
                                            {teeTimeBook.filter(f => f.TeeBox == 10).map((m, i) => (
                                                    <div className="col-md-6 col-sm-6 col-lg-3 padding-0" key={m.TemplateID}>
                                                   <div className={` slot-card ${m.TemplateID == props.slot?.TemplateID && `slot-card-selected`} ${(m.Status == "Booked" ) && 'disableClick'}`} onClick={() => handleSlot(m)} >
                                                       <div className={`${ (m.Status == "Available" || m.Status == "Remaining" || m.Status == null) ? 'slot-card-header' :(m.Status == 'Pending')? 'slot-card-header-pending' : 'slot-card-header-blur' }`}> 
                                                           <div className="row margin-0">
                                                               <div className="col-xs-12 padding-0">
                                                                    <b>{m.Slot.split(':')[0].length === 1 ? '\u00A0' + m.Slot + '\u00A0' : m.Slot}</b>
                                                                </div>
                                                           </div>
                                                       </div>
                                                       <div className="slot-card-available-wrapper">
                                                            <div className="slot-card-available">
                                                                {/* {m.Status ? m.Status : "Available" }{(m.Status != "Booked" && m.Status != 'Pending') ? <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i> : <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>} */}
                                                                <div className="slot-card-available">
                                                                {m.Status === "Available" || m.Status === null ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>Available</span>
                                                                    </div>
                                                                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : m.Status === "Remaining" ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>{m.DisplayStatus}</span>
                                                                    </div>
                                                                    <i className="fa fa-check-circle-o text-green fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : m.Status === "Pending" || m.Status === "Booked" ? (
                                                                    <>
                                                                    <div className="">
                                                                        <span>{m.Status}</span>
                                                                    </div>
                                                                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                    <div className="">
                                                                        <span>Not Available</span>
                                                                    </div>
                                                                    <i className="fa fa-times-circle-o fa-lg margin-lr5" aria-hidden="true"></i>
                                                                    </>
                                                                )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                   </div>
                                               </div>
                                            ))}
                                        </div>      
                                    </div>
                                </div>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal" onClick={onClose}> Close </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default slot;